import React from "react";
import { useTranslation } from "react-i18next";
import s from "./Footer.module.scss";
import packageJson from "../../../package.json";

const Footer = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <div className={s.footerContainer}>
      <div className={s.footer}>
        <div className={s.copyright}>
          <span style={{ marginRight: 2 }}>
            {t("layout.footer.copyright.copyright") +
              year +
              t("layout.footer.copyright.bbmslLimited")}
          </span>
          <span>{t("layout.footer.copyright.allRightsReserved")}</span>
        </div>
        <div className={s.version}>
          {t("layout.footer.version") + packageJson.version}
        </div>
      </div>
    </div>
  );
};

export default React.memo(Footer);
